import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/picket-schedule'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(picketSchedule, uuid) {
    return http.put(`${resource}/${uuid}`, picketSchedule)
  },
  add(picketSchedule) {
    return http.post(`${resource}`, picketSchedule)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
